import React from "react";

const GEAR_ICON_PATHS = {
  braidToLeader: "/icons/gear/braid-to-leader.png",
  gearSet: "/icons/gear/gear-set.png",
  hook: "/icons/gear/hook.png",
  knots: "/icons/gear/knots.png",
  leader: "/icons/gear/leader.png",
  leaderToHookLure: "/icons/gear/leader-to-hook-lure.png",
  line: "/icons/gear/line-braid.png",
  lure: "/icons/gear/lure.png",
  reel: "/icons/gear/reel.png",
  rod: "/icons/gear/rod.png",
  tackleBox: "/icons/gear/tackle-box.png",
};

export default function GearIcon({ type, className = "" }) {
  const iconPath = GEAR_ICON_PATHS[type];
  if (!iconPath) return null;

  return (
    <img
      src={iconPath}
      alt=""
      className={`create-post-gear-icon-img${
        className ? ` ${className}` : ""
      }`}
      aria-hidden="true"
    />
  );
}
